import React from 'react';
import Raven from 'raven-js';

import ErrorPage from '../../Error/Error';

export class ErrorBoundary extends React.Component {
    state = {
        error: false,
        errorMessage: null,
    };

    componentDidCatch(error, info) {
        const errorMessage = `${error ? error.toString() : 'React did not provide an error object.'}`;
        const stack = info ? info.componentStack : 'Stack unavailable';

        this.setState({
            error: true,
            errorMessage: `${errorMessage}\n${stack}`,
        });

        if (typeof window !== 'undefined') {
            Raven.captureException(errorMessage, { extra: info });
        }
    }

    render() {
        if (this.state.error) {
            return (
                <ErrorPage
                    errorCode={500}
                    errorMessage={this.state.errorMessage}
                />
            );
        }

        return this.props.children;
    }
}
